import "./Landing.scss"

const Landing = () => {
    return (
        <div className="landing">Landing</div>
    )
}
export default Landing